// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    SERVER_URL: "",
    production: false,
    googleMapsApiKey: "AIzaSyA6MzAQocq5JW4YFAXerO1NQfeaZIc-0TY",
    useHash: true,
    hmr: false,

    // URL for the first API (change as needed)
    API_URL2: "https://cmsapi.vmatic.co.in", // Production Server Url
    // API_URL2: "http://103.151.107.88:5205", // Development Server Url
    // API_URL2: "http://10.5.50.32:4000", // Local IP_Address Url

    // URL for the second API (change as needed)
    API_URL3: "https://cmsmidapi.vmatic.co.in", // Production Server Url
    // API_URL3: "http://103.151.107.88:5206", // Development Server Url
    // API_URL3: "http://10.5.50.32:4600", // Testing IP_Address Url
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
